// Endpoint Type enum
export enum EndpointType {
    // graphql endpoint type for bff hub
    hubHost = "hubhost",
    // graphql endpoint type for bff bae
    baeHost = "baehost",
}